import styled from 'styled-components';
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../constants.js';
import '../../ui/Div/index.js';
import '../../ui/Image/index.js';
import { LinkButton } from '../../ui/Link/LinkButton.js';
import { Text } from '../../ui/Text.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { Image } from '../../ui/Image/Image.js';
const DEFAULT_ALT_TEXT = 'Card Image';
function WayfindingCardResource({
  headline,
  href,
  body,
  mediaUrl,
  mediaAlt,
  date,
  style = 'default',
  ctaButtonLabel = 'Go'
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary;
  return /*#__PURE__*/jsxs(Div, {
    display: "grid",
    gridTemplateAreas: {
      sm: mobileAreas,
      md: areas
    },
    gridTemplateColumns: {
      sm: '48px auto 1fr',
      md: '172px 1fr auto',
      lg: '200px 1fr auto'
    },
    columnGap: {
      sm: 2,
      md: 4,
      lg: 8
    },
    rowGap: {
      sm: 3,
      md: 0
    },
    alignItems: "center",
    children: [/*#__PURE__*/jsx(GridArea, {
      area: "thumbnail",
      children: /*#__PURE__*/jsx(Image, {
        alt: mediaAlt || DEFAULT_ALT_TEXT,
        src: mediaUrl,
        aspectRatio: 1
      })
    }), /*#__PURE__*/jsx(GridArea, {
      area: "date",
      children: date && /*#__PURE__*/jsx(Text, {
        variant: "legal",
        as: "p",
        color: foregroundSecondary,
        children: date
      })
    }), /*#__PURE__*/jsx(GridArea, {
      area: "title",
      children: /*#__PURE__*/jsx(Text, {
        as: "h3",
        spacingTop: 0,
        variant: {
          sm: 'title4',
          lg: 'title2'
        },
        color: foreground,
        children: headline
      })
    }), /*#__PURE__*/jsx(GridArea, {
      area: "body",
      children: body && /*#__PURE__*/jsx(Text, {
        variant: "body",
        spacingTop: 0,
        as: "p",
        color: foregroundSecondary,
        children: body
      })
    }), /*#__PURE__*/jsx(GridArea, {
      area: "cta",
      children: href && /*#__PURE__*/jsx(Div, {
        justifyContent: "flex-end",
        children: /*#__PURE__*/jsx(LinkButton, {
          href: href,
          "data-qa": ANALYTICS_KEY.CardResourceGrid,
          variant: style === 'primary' ? 'secondary' : 'primary',
          children: ctaButtonLabel
        })
      })
    })]
  });
}
const areas = `
  "thumbnail date cta"
  "thumbnail title cta"
  "thumbnail body cta"
`;
const mobileAreas = `
  "thumbnail title title"
  "body body body"
  "date date cta"
`;
const GRID_AREAS = {
  thumbnail: 'thumbnail',
  date: 'date',
  title: 'title',
  body: 'body',
  cta: 'cta'
};
const GridArea = styled.div.withConfig({
  shouldForwardProp: p => !['area'].includes(p)
})`
  grid-area: ${({
  area
}) => GRID_AREAS[area]};
`;
export { WayfindingCardResource };
//# sourceMappingURL=CardResource.js.map
